<script>
    import { _ } from 'svelte-i18n'
</script>

<footer
    class="border-t border-[#c8c8c8] px-1 pb-1 text-sm font-light italic leading-6 dark:border-[#656565]"
>
    {@html $_('authorize_footer')}
</footer>
